import React from 'react';
import LoginForm from '../components/LoginLayout';

export default function Login() {
  return <LoginForm />;
}
